import { useModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { type History } from "history";

import { useIndependentContractorBadgeRevamp } from "../../Documents/components/IndependentContractorBadge/hooks/useIndependentContractorBadgeRevamp";
import { INDEPENDENT_CONTRACTOR_BADGE_FULL_PATH } from "../../Documents/paths";
import { GetBadgeBottomSheet } from "../../IndependantContractorBadge/BottomSheet/GetBadgeBottomSheet";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function BaseIndependentContractorBadgeRequiredCard(props: {
  history: History;
  shiftId: string;
  state: string;
  qualification: string;
  analyticsMetadata: Record<string, string | boolean | undefined>;
}) {
  const { history, shiftId, state, qualification, analyticsMetadata } = props;
  const modalState = useModalState();
  const { isEnabled } = useIndependentContractorBadgeRevamp();

  return (
    <>
      <ShiftBottomSheetBookabilityCriteriaCard
        title="Badge Required"
        description="This workplace requires a badge to be worn at all times during the shift. Please print your badge and bring it with you to the shift."
        illustrationType="complete-profile"
        footer={
          <Button
            fullWidth
            variant="outlined"
            size="medium"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.INDEPENDENT_CONTRACTOR_BADGE_REQUIRED_BUTTON_CLICKED, {
                shiftId,
                ...analyticsMetadata,
              });

              if (isEnabled) {
                modalState.openModal();
              } else {
                history.push(INDEPENDENT_CONTRACTOR_BADGE_FULL_PATH);
              }
            }}
          >
            View Badge
          </Button>
        }
      />
      <GetBadgeBottomSheet
        state={state}
        qualification={qualification}
        modalState={modalState}
        analyticsMetadata={analyticsMetadata}
      />
    </>
  );
}
